import Screen from '@/styles/Themes/Screen';
import styled, { DefaultTheme } from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius } from '@/styles/Themes/Metrics';
import { CloseIcon } from '@/shared/images/icons/CloseIcon';
import { CartIcon } from '@/shared/images/icons/CartIcon';
import { Button } from '@/common/ui';

interface ICloseIcon extends DefaultTheme {
    onClick: () => void;
}

export const BGImage = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(5px);
`;

export const ModalContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

export const Modal = styled.div`
    background-color: ${cssVars.bg_white_dark3};
    width: 90%;
    height: fit-content;
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    border-radius: ${radius.small};
    box-shadow: ${cssVars.shadow_modal};

    ${Screen.ipad} {
        width: 490px;
    }
    ${Screen.desktop} {
        width: 474px;
    }
`;

export const CartEmptyHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    height: 25px;
    width: 100%;
`;

export const CartEmptyContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px 20px;
    ${Screen.ipad} {
        padding: 18px;
    }
    ${Screen.desktop} {
        padding: 22px 20px 10px;
    }
`;

export const IconCart = styled(CartIcon)`
    ${Screen.ipad} {
        width: 100px;
        height: 100px;
    }
    ${Screen.desktop} {
        width: 85px;
        height: 85px;
    }
`;

export const CartEmptyTitle = styled.h1`
    ${Text.Full.large.medium};
    color: ${cssVars.fg_gray1_white};
    margin: 23px 0 3px;

    ${Screen.ipad} {
        margin: 26px 0 6px;
    }
    ${Screen.desktop} {
        margin: 28px 0 10px;
    }
`;

export const CartEmptyDescription = styled.p`
    ${Text.Mobile.normal.regular};
    color: ${cssVars.fg_gray2_white};
    text-align: center;
    margin: 0 0 21px;

    ${Screen.ipad} {
        margin: 0 67px 29px;
        ${Text.Ipad.normal.regular};
    }
    ${Screen.desktop} {
        margin: 0 65px 33px;
        ${Text.Desktop.normal.regular};
    }
`;

export const ButtonSendingHome = styled(Button)`
    width: 90%;
    margin-bottom: 20px;

    ${Screen.desktop} {
        margin-bottom: 22px;
    }
    ${Screen.desktop} {
        width: 86%;
        margin-bottom: 38px;
    }
`;

export const CloseButtonWithIcon = styled(CloseIcon)``;

export const CloseButton = styled.div<ICloseIcon>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: ${cssVars.bg_ash_normal};
    border-radius: ${radius.huge};
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;

    ${Screen.ipad} {
        width: 40px;
        height: 40px;
    }

    ${Screen.desktop} {
        width: 36px;
        height: 36px;
    }

    &:hover {
        background: ${cssVars.bg_white_dark3};
        box-shadow: ${cssVars.shadow_card_default};
    }
`;
